// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import colors from '../config/colors';
import settings from '../config/settings';

import Nav from './Nav';
import SafeLink from './SafeLink';

const FooterWrapper = styled.footer`
  align-items: center;
  background: ${colors.footer.bg};
  bottom: 0;
  display: flex;
  font-size: 13px;
  height: ${settings.footerHeight};
  left: ${props => props.navRevealed ? `calc(-100% + ${settings.navSize})` : 0};
  line-height: 1;
  justify-content: space-between;
  padding: 0 10px;
  position: fixed;
  width: 100%;
  ${settings.navTransition && css`transition: ${settings.navTransition};`}
  a {
    color: #ECEFFF;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  > a {
    color: ${colors.text.light};
  }
`;

type Props = {
  navRevealed: boolean
}

const Footer = (props: Props) => (
  <FooterWrapper navRevealed={props.navRevealed}>
    <SafeLink href="http://baartgroup.com">
      &copy; Baart Industrial Group
    </SafeLink>
    <Nav inline>
      <li>
        <Link to="/contact">Contact</Link>
      </li>
      <li>
        <SafeLink href="http://baartgroup.com/wp-content/uploads/2017/08/Baart-Terms-2017.pdf">
          Terms
        </SafeLink>
      </li>
      <li>
        <SafeLink href="http://baartgroup.com/wp-content/uploads/2014/03/Baart-Warranty.pdf">
          Warranty
        </SafeLink>
      </li>
    </Nav>
  </FooterWrapper>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js